'use strict'

const state = () => {
    return {
        videos: []
    }
}

const getters = {
    videos: function (state) {
        return state.videos
    },
    hasVideos: function (state) {
        return Array.isArray(state.videos) && state.videos.length > 0
    }
}

const actions = {
    async fetchHistory({ commit, state }, { limit = 30 } = {}) {
        if (Array.isArray(state.videos) && state.videos.length > 0) {
            return;
        }

        let hasError = false;

        await this.client.Get('/videos/history', {
            progressbar: false,
            query: {
                limit: limit
            },
            callback: function (response) {
                commit('setVideos', response.video);
            },
            onError: function () {
                hasError = true;
            }
        });

        if (true === hasError) {
            throw new Error('No se pudo obtener el historial de videos.');
        }
    },
}

const mutations = {
    setVideos (state, videos) {
        state.videos = videos ?? []
    },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
